/* eslint-disable no-console */
import { useScript } from 'core/hooks/useScript';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import { trackSubscribeVkButton } from 'core/tracking';
import React, { useEffect } from 'react';

const buttonId = 'senler-vk-btn';
const vkGroupId = '122515244';
const subscriptionId = '81737';

type ISubscribeVkButtonProps = {} & WithStyles<typeof styles>;

const SubscribeVkButton: React.FC<ISubscribeVkButtonProps> = () => {
    const [loaded] = useScript('//senler.ru/dist/web/js/senler.js?5');

    useEffect(() => {
        if (loaded) {
            try {
                (window as any).Senler.ButtonSubscribe(buttonId, {
                    completeCallback: function() {
                        console.log('Запрос пришел успешно');
                    },
                    cancelCallback: function() {
                        console.log('Пользователь отписался');
                    },
                    successCallback: function() {
                        trackSubscribeVkButton();
                        console.log('Пользователь подписался');
                    },
                    errorCallback: function() {
                        console.log('Ошибка при запросе');
                    },
                });

                // Реализация senler.js ждет события для инициализации
                const event = new CustomEvent('DOMContentLoaded');
                document.dispatchEvent(event);
            } catch (e) {
                console.log(e);
            }
        }
    }, [loaded]);

    return (
        <div
            id={buttonId}
            data-vk_group_id={vkGroupId}
            data-subscription_id={subscriptionId}
            data-text="Подписаться на рассылку Вконтакте"
            data-alt_text="Отменить подписку"
        ></div>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        '@global': {
            [`#${buttonId}`]: {
                backgroundColor: theme.colors.accent,
                margin: '1rem 0',
                color: 'white',
            },
        },
    });

export default injectSheet(styles)(SubscribeVkButton);
